import { createI18n } from 'vue-i18n'

// 定义翻译内容
const messages = {
  'zh-Hant': {
    home: '首页',
    productCategory: '產品分類',
    contactUs: '聯絡我們',
    electricMotorcycles: '電動摩托車',
    motorcycleParts: '電動摩托車配件',
    batteryExchange: '電動摩托車換電櫃',
    evChargers: 'EV充電椿',
    evCables: 'EV充電線',
    evAdapters: 'EV充電轉接頭',
    traditionalChinese: '繁體中文',
    english: '英文',
    contactTitle: '聯絡我們',
    startNavigation: '開始導航',
    phone1: '852 2111 9678',
    phone2: '852 6686 0815',
    email: 'cs\\@drmotor.hk', // 正确转义@符号
    address: '觀塘海濱道151號廣生行地下6號舖',
    footer: 'Footer',
    contactDesc: '無論您有任何查詢或建議，歡迎隨時與我們聯繫',
    phone: '電話',
    whatsappWechat: 'WhatsApp/微信',
    emailLabel: '電子郵件',
    addressLabel: '地址',
    followUs: '關注我們',
    facebook: 'Facebook',
    whatsapp: 'WhatsApp',
    instagram: 'Instagram'
  },
  'en': {
    home: 'Home',
    productCategory: 'Products',
    contactUs: 'Contact Us',
    electricMotorcycles: 'Electric Motorcycles',
    motorcycleParts: 'Motorcycle Parts',
    batteryExchange: 'Battery Exchange',
    evChargers: 'EV Chargers',
    evCables: 'EV Cables',
    evAdapters: 'EV Adapters',
    traditionalChinese: 'Traditional Chinese',
    english: 'English',
    contactTitle: 'Contact Us',
    startNavigation: 'Start Navigation',
    phone1: '852 2111 9678',
    phone2: '852 6686 0815',
    email: 'cs\\@drmotor.hk', // 正确转义@符号
    address: 'Shop 6, G/F, Kwong Sang Hong Building, 151 Kwun Tong Promenade, Kwun Tong',
    footer: 'Footer',
    contactDesc: 'If you have any questions or suggestions, please feel free to contact us',
    phone: 'Phone',
    whatsappWechat: 'WhatsApp/WeChat',
    emailLabel: 'Email',
    addressLabel: 'Address',
    followUs: 'Follow Us',
    facebook: 'Facebook',
    whatsapp: 'WhatsApp',
    instagram: 'Instagram'
  }
}

// 创建i18n实例
const i18n = createI18n({
  legacy: false, // 使用Composition API必须设置legacy为false
  locale: 'zh-Hant', // 默认语言为繁体中文
  fallbackLocale: 'en', // 回退语言为英文
  messages
})

export default i18n